// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".payback-points__logo[data-v-61f151f0]{height:45px!important;margin-top:11px;width:120px!important}.payback-points .col[data-v-61f151f0]{line-height:24px}.payback-points .col-100pct[data-v-61f151f0]{width:100%}.payback-points .extra-points[data-v-61f151f0]{color:#0f9d58}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
